module.exports = __webpack_public_path__ + "static/media/bphtb1.e7036133.png";